import { render, staticRenderFns } from "./ArcadiaUi.vue?vue&type=template&id=7afb2daa"
import script from "./ArcadiaUi.vue?vue&type=script&lang=js"
export * from "./ArcadiaUi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports